import React, { Fragment } from "react"
import propTypes from "prop-types"
import parse from "html-react-parser"

export default function TitleBlock(props) {
  const { className, title, icon, renderHTML } = props

  const renderIcon = () => {
    if (!icon) return

    return <i className={icon}></i>
  }

  return (
    <Fragment>
      <h2 className={`TitleBlock ${className}`}>
        {renderIcon()}
        {renderHTML ? parse(title) : title}
      </h2>
    </Fragment>
  )
}

TitleBlock.propTypes = {
  className: propTypes.string,
  title: propTypes.string,
  icon: propTypes.string,
}

TitleBlock.defaultProps = {
  className: "",
  title: "",
  icon: "",
}
